var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSkipNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53332 2.98344L13.9917 9.30844C14.55 9.68344 14.55 10.5001 13.9917 10.8668L4.52498 17.1918C3.89998 17.6084 3.06665 17.1584 3.06665 16.4084V3.76677C3.06665 3.01677 3.90832 2.56677 4.53332 2.98344Z",
    fill: "#006CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 17.1836C16.9084 17.1836 17.2834 16.8086 17.2834 16.3502V3.65023C17.2834 3.19189 16.9084 2.81689 16.45 2.81689C15.9917 2.81689 15.6167 3.19189 15.6167 3.65023V16.3502C15.6167 16.8086 15.9917 17.1836 16.45 17.1836Z",
    fill: "#006CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkipNext);
export default __webpack_public_path__ + "static/media/icon-skip-next.f81a94a96e70ae4101886d9849c93b2f.svg";
export { ForwardRef as ReactComponent };